class ChartWidget extends BaseWidget<ChartWidgetResultVM, ReportConfig> {
    override widgetType = WidgetType.Chart;
    
    chartVM: IChartVM;
    
    get chartDefinition() {
        return this.itemConfig.chartDefinition;
    }

    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);
    }

    setConfig(config) {
        this.itemConfig = new ReportConfig(config);
    }

    setResult(result) {
        this.result = new ChartWidgetResultVM(result);

        //Update the fields/metrics because their names may have changed, this is when using date variables in the name. [YEAR], [MONTH]...
        if (result.itemConfig) {
            (this.itemConfig as ReportConfig).updateFieldsGroupsMetrics(result.itemConfig);
        }
    }

    setup() {

        // attach the .equals method to Array's prototype to call it on any array
        if (!Array.prototype.equals) {
            Array.prototype.equals = function (array) {
                return this.length === array.length && this.every((value, index) => value === array[index]);
            }
        }

        if (!String.prototype.equals) {
            String.prototype.equals = function (string) {
                return this.toString() === string;
            }
        }

        this.chartVM = {
            fromPDF: workbook.workbookConfig.isPrinting,
            $canvas: $('.chartdiv', this.$reportContent),
            result: this.result,
            $context: this.$reportContent,
            colors: [],
            generateAxes: ko.observable(false),
            mixedChartType: ko.observable(false),
            allowColorPerSerie: ko.observable(true),
            chartDefinition: this.itemConfig.chartDefinition,
            hasGrouping: this.result.groupFields && this.result.groupFields.length > 0,
            chartStatus: [ChartStatus.Ready, ChartStatus.Starting],
            debug: false,
            groupSerieValues: []
        } as IChartVM;

        this.applyObservable(this.chartVM);
        this.popStatus();
        this.createChart(false);

        this.setupChart();
    }

    setupChart() {

        let metricFields = this.result.metricFields;

        for (const field of this.itemConfig.fields()) {
            field.index = this.result.fieldNames.find(x => x.queryName === field.queryName)?.index;
        }

        let hasGroup = this.result.groupFields?.length > 0;
        if (hasGroup) {
            for (const field of this.result.groupFields) {
                let fieldName = this.result.fieldNames.find(x => x.queryName === field.name);
                field.fieldName = fieldName;
            }
        }

        let dataSource = this.prepareDataSource(metricFields);

        let dxChartType = ChartService.getDxChartType(this.chartDefinition.chartType());
        let $canvas = $(".canvasChart", this.$reportContent);

        this.getChartOptions(dxChartType, dataSource, metricFields, $canvas);
    }

    private createChartAndSaveSettings() {
        this.createChart(true);
    }

    private createChart(save: boolean = true) {
        let self = this;

        if (this.getStatus() !== ChartStatus.Ready) {
            this.log("createChart not ready");
            return;
        }
        this.log("createChart " + Date());
        this.pushStatus(ChartStatus.Rendering);
        try {
            this.chartVM.colorPosition = -1;
            this.chartVM.colors = ChartService.colorThemes[this.chartVM.chartDefinition.colorTheme() - 1].colors;

            if (save) {
                this.setupChart();
            }

        } catch (error) {
            console.log(error);
        }
        this.popStatus();
    }

    getChartOptions(dxChartType: DxChartType, dataSource, metricFields: Array<MetricField>, $canvas) {

        this.chartVM.mixedChartType(this.chartDefinition.chartType() === ChartType.Mixed);
        let generateAxes = !(this.chartDefinition.chartType() === ChartType.Donut ||
            this.chartDefinition.chartType() === ChartType.Pie ||
            this.chartDefinition.chartType() === ChartType.Polar ||
            this.chartDefinition.chartType() === ChartType.RadarArea);

        this.chartVM.generateAxes(generateAxes);

        let allowColorPerSerie = !this.chartVM.hasGrouping && dxChartType !== DxChartType.Pie /*&& dxChartType !== "polarArea"*/;
        this.chartVM.allowColorPerSerie(allowColorPerSerie);

        if (this.chartDefinition.chartType() === ChartType.Pie || this.chartDefinition.chartType() === ChartType.Donut) {
            //let chartOptions = getPieChartOptions(chartType, chartDefinition, dataSource, metricFields, chartVM);
            let chartOptions = this.getRegularChartOptions(dxChartType, dataSource, metricFields);
            ChartService.disposeChart($canvas, "dxPieChart");
            if (!$canvas.data("dxPieChart")) {
                $canvas.dxPieChart(chartOptions);
            }
            else {
                $canvas.dxPieChart("instance").option(chartOptions);
                $canvas.dxPieChart("instance").option("commonSeriesSettings.label.backgroundColor", chartOptions.commonSeriesSettings.label.backgroundColor);
                $canvas.dxPieChart("instance").option("commonSeriesSettings.label.font.color", chartOptions.commonSeriesSettings.label.font.color);
            }
        }
        else {
            if (this.chartDefinition.chartType() === ChartType.Polar || this.chartDefinition.chartType() === ChartType.Radar || this.chartDefinition.chartType() === ChartType.RadarArea) {
                let chartOptions = this.getRegularChartOptions(dxChartType, dataSource, metricFields) as any;
                chartOptions.commonSeriesSettings = {
                    type: this.chartDefinition.chartType() === ChartType.Polar ?
                        "stackedbar" :
                        (
                            this.chartDefinition.chartType() === ChartType.Radar ?
                                "line" :
                                "area"
                        ),
                };
                ChartService.disposeChart($canvas, "dxPolarChart");
                if (!$canvas.data("dxPolarChart")) {
                    $canvas.dxPolarChart(chartOptions);
                }
                else {
                    $canvas.dxPolarChart("instance").option(chartOptions);
                    $canvas.dxPolarChart("instance").option("commonSeriesSettings.label.backgroundColor", chartOptions.commonSeriesSettings.label.backgroundColor);
                    $canvas.dxPolarChart("instance").option("commonSeriesSettings.label.font.color", chartOptions.commonSeriesSettings.label.font.color);
                }
            }
            else {
                let chartOptions = this.getRegularChartOptions(dxChartType, dataSource, metricFields) as any;
                chartOptions.legend = ko.toJS(chartOptions.legend);
                ChartService.disposeChart($canvas, "dxChart");
                if (!$canvas.data("dxChart")) {
                    $canvas.dxChart(chartOptions);
                }
                else {
                    $canvas.dxChart("instance").option(chartOptions);
                    $canvas.dxChart("instance").option("commonSeriesSettings.label.backgroundColor", chartOptions.commonSeriesSettings.label.backgroundColor);
                    $canvas.dxChart("instance").option("commonSeriesSettings.label.font.color", chartOptions.commonSeriesSettings.label.font.color);
                }
            }
        }
    }

    createSerie(dxChartType: DxChartType, metricField: MetricField, argumentField: string, sizeFieldName: string, formatType: string, groupSerieValue = "") {
        let currencyCode = this.result.currencyCode;

        let serieType = this.chartDefinition.chartType() === ChartType.Mixed ? metricField.yAxisChartDefinition.chartType() : this.chartDefinition.chartType();
        let serieName = metricField.displayName();
        if (this.chartVM.hasGrouping) {
            if (this.result.metricFields.filter(x => x.visible()).length === 1) {
                serieName = groupSerieValue;
            }
            else {
                serieName += " " + groupSerieValue;
            }
        }

        let serie = {
            type: this.chartDefinition.chartType() === ChartType.Mixed ? ChartService.getDxChartType(metricField.yAxisChartDefinition.chartType()) : dxChartType,
            valueField: metricField.queryName + (this.chartVM.hasGrouping ? `_group_${groupSerieValue}` : ""),
            stack: 'G' + metricField.yAxisChartDefinition.stackGroup(),
            axis: metricField.yAxisChartDefinition.yAxisID() === "y-left" ? "left" : "right",
            //cornerRadius: 6,
            name: replaceBasicHtmlContent(serieName),
            color: this.chartVM.allowColorPerSerie() && this.chartDefinition.colorPerSerie() && metricField.color()?.toUpperCase() !== "#FFFFFF" ? metricField.color() : undefined,
            argumentField: argumentField,
            sizeField: sizeFieldName,
            label: {
                //alignment: "center", //HorizontalAlignment: center, left, right
                //showForZeroValues: false,
                //visible: true
                //argumentFormat:
                //backgroundColor:
                //border
                //connector
                //customizeText
                //displayFormat: "{seriesName}: {valueText}",
                //displayFormat: labelDisplayFormat,
                format: {
                    style: formatType,
                    currency: currencyCode,
                    currencyDisplay: "narrowSymbol",
                    precision: this.chartDefinition.labelDecimalPlaces() === -1 ? metricField.metricFormat.decimalPlaces : this.chartDefinition.labelDecimalPlaces(),
                    currencySign: metricField.metricFormat.accountingStyle ? "accounting" : "standard",
                    largerNumber: labelFormatEnumToString(this.chartDefinition.labelFormat()),
                },
                //horizontalOffset
                //verticalOffset
                //position: //'inside' | 'outside'
                //rotationAngle
            },
            point: { visible: true, },
            border: {
                visible: serieType === ChartType.Bubble || serieType === ChartType.Area || serieType === ChartType.StackedArea,
                width: this.chartDefinition.chartType() === ChartType.Bubble ? 1 : 2,
                color: this.chartDefinition.chartType() === ChartType.Bubble ? "#4e4e4e" : undefined,
            },
            //ignoreEmptyPoints: false,
            tag: metricField,
        };

        return serie;
    }

    getSeries(dxChartType: DxChartType, metricFields: Array<MetricField>, leftAxis, rightAxis) {
        let series = [];
        let currencyCode = this.result.currencyCode;

        let argumentField = this.result.groupFields?.length > 0 ? "xGroupArgument" : "xArgument";

        let metrics = metricFields;
        if (dxChartType === DxChartType.StackedBar || dxChartType === DxChartType.StackedSplineArea) {
            metrics = [...metrics.sort((a, b) => { return a.yAxisChartDefinition.stackGroup() - b.yAxisChartDefinition.stackGroup(); })]
        }

        if (this.chartDefinition.chartType() === ChartType.Scatter) {
            let xField = metrics.find(x => x.yAxisChartDefinition.scatterType() === BubbleScatterType.XAxis);
            if (xField) {
                argumentField = xField.queryName;
            }
        }

        var sizeFieldName = undefined;
        if (this.chartDefinition.chartType() === ChartType.Bubble) {
            let xField = metrics.find(x => x.yAxisChartDefinition.bubbleType() === BubbleScatterType.XAxis);
            if (xField) {
                argumentField = xField.queryName;
            }

            let sizeField = metrics.find(x => x.yAxisChartDefinition.bubbleType() === BubbleScatterType.BubbleSize);
            if (sizeField) {
                sizeFieldName = sizeField.queryName;
            }
        }

        for (const metricField of metrics) {
            if (metricField.visible() && metricField.yAxisChartDefinition.isSerie(this.chartDefinition)) {

                if (metricField.yAxisChartDefinition.yAxisID() === "y-left") {
                    leftAxis.visible = true;
                    if (this.chartDefinition.showMetricsYAxis()) {
                        if (leftAxis.title.text !== "") {
                            leftAxis.title.text += ", ";
                        }
                        leftAxis.title.text += replaceBasicHtmlContent(metricField.displayName());
                    }
                }
                else {
                    rightAxis.visible = true;
                    if (this.chartDefinition.showMetricsYAxis()) {
                        if (rightAxis.title.text !== "") {
                            rightAxis.title.text += ", ";
                        }
                        rightAxis.title.text += replaceBasicHtmlContent(metricField.displayName());
                    }
                }
            }
        }

        if (!this.chartVM.hasGrouping) {
            for (const metricField of metrics) {
                let type = metricField.metricFormat.format == FieldFormatEnum.Currency ? "currency" : (metricField.metricFormat.format == FieldFormatEnum.Percentage ? "percent" : "decimal");

                //Don't create a tooltip format using the constructor because it doesn't work
                metricField.tooltipFormat = {
                    style: type,
                    currency: currencyCode,
                    currencyDisplay: "narrowSymbol",
                    precision: metricField.metricFormat.decimalPlaces,
                    currencySign: metricField.metricFormat.accountingStyle ? "accounting" : "standard",
                };

                if (metricField.visible() && metricField.yAxisChartDefinition.isSerie(this.chartDefinition)) {
                    let serie = this.createSerie(dxChartType, metricField, argumentField, sizeFieldName, type);
                    series.push(serie)
                }
            }
        }
        else {
            for (const groupSerieValue of this.chartVM.groupSerieValues) {
                for (const metricField of metrics) {
                    let type = metricField.metricFormat.format == FieldFormatEnum.Currency ? "currency" : (metricField.metricFormat.format == FieldFormatEnum.Percentage ? "percent" : "decimal");

                    //Don't create a tooltip format using the constructor because it doesn't work
                    metricField.tooltipFormat = {
                        style: type,
                        currency: currencyCode,
                        currencyDisplay: "narrowSymbol",
                        precision: metricField.metricFormat.decimalPlaces,
                        currencySign: metricField.metricFormat.accountingStyle ? "accounting" : "standard",
                    };

                    if (metricField.visible() && metricField.yAxisChartDefinition.isSerie(this.chartDefinition)) {
                        let serie = this.createSerie(dxChartType, metricField, argumentField, sizeFieldName, type, groupSerieValue.xArgument);
                        series.push(serie);
                    }
                }
            }
        }

        return series;
    }

    customizeTooltip(arg, xMetric: MetricField, bubbleSizeMetric: MetricField) {
        let argumentText = this.chartDefinition.chartType() === ChartType.Scatter || this.chartDefinition.chartType() === ChartType.Bubble ?
            (this.chartVM.hasGrouping ? arg.point.data.xGroupArgument : arg.point.data.xArgument) : arg.argumentText;

        let tooltipFormat = arg.point.series.tag.tooltipFormat;
        
        //let valueText = DevExpress.localization.formatNumber(arg.value, tooltipFormat);

        var dx = DevExpress as any;
        let valueText = dx.formatHelper.format(arg.value, tooltipFormat);

        let text = `${argumentText}<br/>${arg.seriesName}: ${valueText}`;
        let backgroundColor = arg.point.getColor();
        text = `<span style="background-color:${backgroundColor}; height: 12px; width: 12px; display: inline-block; margin-right: 2px; "></span>` + text;

        if (this.chartDefinition.chartType() === ChartType.StackedBar || this.chartDefinition.chartType() === ChartType.HorizontalBarStacked || this.chartDefinition.chartType() === ChartType.StackedArea) {
            text += `<br/>Percent: ${arg.percentText}`;
            let totalText = DevExpress.localization.formatNumber(arg.total, tooltipFormat);
            text += `<hr/>Total: ${totalText}`;
        }
        if (this.chartDefinition.chartType() === ChartType.Pie || this.chartDefinition.chartType() === ChartType.Donut) {
            text += `<br/>Percent: ${arg.percentText}`;
        }
        if (this.chartDefinition.chartType() === ChartType.Scatter) {
            let xMetricValueText = DevExpress.localization.formatNumber(arg.point.data[xMetric.queryName], xMetric.tooltipFormat);
            text += `<br/>${replaceBasicHtmlContent(xMetric.displayName())}: ${xMetricValueText}`;
        }
        if (this.chartDefinition.chartType() === ChartType.Bubble) {
            if (xMetric) {
                let xMetricValueText = DevExpress.localization.formatNumber(arg.point.data[xMetric.queryName], xMetric.tooltipFormat);
                text += `<br/>${replaceBasicHtmlContent(xMetric.displayName())}: ${xMetricValueText}`;
            }
            let bubbleSizeValueText = DevExpress.localization.formatNumber(arg.point.data[bubbleSizeMetric.queryName], bubbleSizeMetric.tooltipFormat);
            text += `<br/>${replaceBasicHtmlContent(bubbleSizeMetric.displayName())}: ${bubbleSizeValueText}`;
        }

        return {
            html: text,
        };
    }

    customizeLabelText(arg) {
        let text = "";

        if (this.chartDefinition.labelShowElement()) {
            if (this.chartVM.hasGrouping)
                text = `${arg.point.data.xGroupArgument}`;
            else
                text = `${arg.point.data.xArgument}`;
        }

        if (this.chartVM.hasGrouping && this.chartDefinition.labelShowGroupingElement()) {
            if (text !== "") {
                text += "<br>";
            }
            text += `${arg.point.data.xArgument}`;
        }

        if (this.chartDefinition.labelShowMetricName()) {
            if (text !== "") {
                text += "<br>";
            }
            text += `${arg.seriesName}`;
        }

        if (this.chartDefinition.labelShowValue()) {
            if (text !== "") {
                text += "<br>";
            }
            text += `${arg.valueText}`;
        }

        return text;
    }

    getFirstYAxisField(bubbleScatterType: BubbleScatterType, metricFields: Array<MetricField>, typeField: "bubbleType" | "scatterType" = "bubbleType"): MetricField {
        let field = metricFields.find(x => x.yAxisChartDefinition.getBubbleOrScatterType(typeField)() === BubbleScatterType.YAxis && !x.visible());
        if (field) {
            field.yAxisChartDefinition.setBubbleOrScatterType(typeField, bubbleScatterType);
        }
        else {
            let fields = metricFields.filter(x => x.yAxisChartDefinition.getBubbleOrScatterType(typeField)() === BubbleScatterType.YAxis);
            if (fields.length >= 2) {
                field = fields[1];
                field.yAxisChartDefinition.setBubbleOrScatterType(typeField, bubbleScatterType);
            }
            else {
                field = undefined;
            }
        }

        return field;
    }

    getRegularChartOptions(dxChartType, dataSource, metricFields: Array<MetricField>) {
        let self = this;
        let series = [];

        let xMetric: MetricField = undefined;
        let bubbleSizeMetric: MetricField = undefined;

        if (this.chartDefinition.chartType() === ChartType.Bubble) {
            xMetric = metricFields.find(x => x.yAxisChartDefinition.bubbleType() === BubbleScatterType.XAxis);
            if (!xMetric) {
                xMetric = this.getFirstYAxisField(BubbleScatterType.XAxis, metricFields);
            }

            bubbleSizeMetric = metricFields.find(x => x.yAxisChartDefinition.bubbleType() === BubbleScatterType.BubbleSize);
            if (!bubbleSizeMetric) {
                bubbleSizeMetric = this.getFirstYAxisField(BubbleScatterType.BubbleSize, metricFields);
            }
        }
        else {
            if (this.chartDefinition.chartType() === ChartType.Scatter) {
                xMetric = metricFields.find(x => x.yAxisChartDefinition.scatterType() === BubbleScatterType.XAxis);
                if (!xMetric) {
                    xMetric = this.getFirstYAxisField(BubbleScatterType.XAxis, metricFields, "scatterType");
                }
            }
        }

        let leftAxis = {
            visible: false,
            title: {
                text: "",
                font: {
                    size: 12,
                },
            },
        };

        let rightAxis = {
            visible: false,
            title: {
                text: "",
                font: {
                    size: 12,
                }
            },
        };

        series = this.getSeries(dxChartType, metricFields, leftAxis, rightAxis);

        let valueAxis = [];

        if (leftAxis.visible) {
            valueAxis.push({
                name: 'left',
                position: 'left',
                //showZero: true,
                synchronizedValue: 0,
                title: leftAxis.title,
                maxValueMargin: this.chartDefinition.axisValueMargin(),
                minValueMargin: this.chartDefinition.axisValueMargin(),
            });
        }

        if (rightAxis.visible) {
            valueAxis.push({
                name: 'right',
                position: 'right',
                //showZero: true,
                synchronizedValue: 0,
                title: rightAxis.title,
                maxValueMargin: this.chartDefinition.axisValueMargin(),
                minValueMargin: this.chartDefinition.axisValueMargin(),
            });
        }

        let legendTitle = "";
        if (this.chartVM.hasGrouping) {
            let visibleMetrics = this.result.metricFields.filter(x => x.visible());
            if (visibleMetrics.length === 1) {
                legendTitle = replaceBasicHtmlContent(visibleMetrics[0].displayName());
            }
        }

        let chartOptions = {
            palette: ChartService.getColorsOfTheme(this.chartDefinition.colorTheme()),
            rotated: this.chartDefinition.chartType() === ChartType.HorizontalBar || this.chartDefinition.chartType() === ChartType.HorizontalBarStacked,
            dataSource: dataSource,
            redrawOnResize: true,
            //title: ' ',
            argumentAxis: {
                //tickInterval: 10,
                label: {
                    displayMode: this.chartDefinition.getaxisLabelDisplayMode(), // "rotate" | "stagger",
                    rotationAngle: this.chartDefinition.axisLabelAngle(),
                    indentFromAxis: 5,
                    overlappingBehavior: "rotate",
                },
                title: {
                    text: this.chartDefinition.showMetricsYAxis() && (this.chartDefinition.chartType() === ChartType.Scatter || this.chartDefinition.chartType() === ChartType.Bubble) ? replaceBasicHtmlContent(xMetric?.displayName?.()) : undefined,
                    font: {
                        size: 12,
                    },
                },
            },
            tooltip: {
                enabled: true,
                shared: false,
                zIndex: 120,
                customizeTooltip(arg) {
                    return self.customizeTooltip(arg, xMetric, bubbleSizeMetric);
                },
            },
            valueAxis: valueAxis,
            series: series,
            legend: ChartService.getLegendOptions(this.chartDefinition.legendPosition, legendTitle),
            commonSeriesSettings: {
                label: {
                    //https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxChart/Configuration/valueAxis/#maxValueMargin 
                    alignment: this.chartDefinition.labelAlign() === FontAlignmentEnum.Start ? "right" : (this.chartDefinition.labelAlign() === FontAlignmentEnum.End ? "left" : this.chartDefinition.labelAlign()), // "center", //HorizontalAlignment: center, left, right
                    //argumentFormat:
                    backgroundColor: this.chartDefinition.labelApplyBackgroundColor() ? undefined : "none",
                    font: {
                        color: !this.chartDefinition.labelFontColor() ? undefined : this.chartDefinition.labelFontColor(),
                    } as any,
                    //border
                    connector: {
                        visible: this.chartDefinition.labelConnector(),
                    },
                    //horizontalOffset
                    //verticalOffset
                    position: this.chartDefinition.labelPosition(),
                    customizeText(arg) {
                        return self.customizeLabelText(arg);
                    },
                    rotationAngle: this.chartDefinition.labelRotationAngle(),
                    showForZeroValues: false,
                    visible: this.chartDefinition.labelVisibility(),
                    //point: { visible: true, },
                    //border: { visible: true, width: 2, }
                },
            },
            resolveLabelOverlapping: this.chartDefinition.labelOverlapping(),
            useSpiderWeb: this.chartDefinition.chartType() === ChartType.Radar || this.chartDefinition.chartType() === ChartType.RadarArea,
            onPointClick(e) {
                if (self.chartVM.fromPDF) {
                    return;
                }

                if (isMobile()) {
                    if (e.target.isSelected()) {
                        self.onDrillDown(e);
                    } else {
                        e.target.select();
                    }
                }
                else {
                    self.onDrillDown(e);
                }
            },
            animation: {
                enabled: !self.chartVM.fromPDF,
            },
            zoomAndPan: {
                argumentAxis: "both",  // or "zoom" | "pan" | "none"
                //valueAxis: "both",      // or "zoom" | "pan" | "none"
                dragToZoom: true,
            },
            onZoomEnd: function (e) {
                if (e.actionType === "zoom") {
                    e.component.option("scrollBar.visible", e.zoomFactor !== 1);
                }
            },
            onZoomStart(e: DevExpress.viz.dxChart.ZoomStartEvent) {
                if (e.actionType === "zoom") {
                    // If ctrl is not pressed, cancel the zoom
                    if (!e.event.ctrlKey) {
                        e.cancel = true; // Cancel zoom if ctrl is not pressed
                    }
                    else {
                        e.event.preventDefault(); // Prevent default zoom behavior
                    }
                }
            },
        };

        return chartOptions;
    }

    prepareDataSource(metricFields: Array<MetricField>) {
        this.result.warningVisible(false);
        let result = this.result.result;

        if (result && this.chartDefinition.chartType() === ChartType.Pie || this.chartDefinition.chartType() === ChartType.Donut) {
            for (const metricField of this.result.fieldNames.filter(x => x.isMetric)) {
                let valueField = this.chartVM.dataSource ? metricField.queryName : metricField.index;
                if (!result.every(x => x[valueField] < 0) && result.some(x => x[valueField] < 0)) {
                    this.result.warningVisible(true);
                    break;
                }
            }
        }

        if (this.chartVM.dataSource) {
            return this.chartVM.dataSource;
        }

        let hasGroup = this.chartVM.hasGrouping;

        const zeroPad = (num, places) => String(num).padStart(places, '0');
        const stringfy = (value, stringSize = 100) => {
            let type = typeof value;
            if (type === "number" || type === "bigint") {
                return zeroPad(value, 15);
            }
            else {
                return value?.toString().padEnd(stringSize, ' ').substring(0, stringSize);
            }
        };

        let newResult = [];

        if (result) {
            for (const data of result) {
                let obj = {} as any;
                //map all fields indexes to queryName
                for (const field of this.result.fieldNames) {
                    let value = data[field.index];
                    obj[field.queryName] = value;
                }

                //map xArgument - all argument fields concatenated
                for (const field of this.itemConfig.fields()) {
                    let value = data[field.index];
                    if (value && typeof value === "string") {
                        value = replaceBasicHtmlContent(value);
                    }

                    if (!field.visible()) {
                        continue;
                    }

                    if (obj.xArgument === undefined) {
                        obj.xArgument = "";
                        obj.xArgumentSort = "";
                    }
                    else {
                        obj.xArgument += `${irSettings.columnSeparatorForHtml}`;
                        obj.xArgumentSort += "|";
                    }

                    if (field.autoGrouping() !== AutoGroupingEnum.None) {
                        let output = getAutoGroupingText(value, field.autoGrouping());
                        obj.xArgument += `${output}`;
                        obj.xArgumentSort += stringfy(value);
                    }
                    else {
                        obj.xArgument += `${value === null ? irSettings.nullText : value !== undefined ? value : ""}`;
                        obj.xArgumentSort += stringfy(obj.xArgument);
                    }
                }

                //map xGroupArgument - all argument group fields concatenated
                if (hasGroup) {

                    for (const groupField of this.result.groupFields) {
                        let field = groupField.fieldName;
                        if (!field.field.visible) {
                            continue;
                        }

                        let value = data[field.index];
                        if (value && typeof value === "string") {
                            value = replaceBasicHtmlContent(value);
                        }

                        if (obj.xGroupArgument === undefined) {
                            obj.xGroupArgument = "";
                            obj.xGroupArgumentSort = "";
                        }
                        else {
                            obj.xGroupArgument += `${irSettings.columnSeparatorForHtml}`;
                            obj.xGroupArgumentSort += "|";
                        }

                        if (field.autoGrouping !== AutoGroupingEnum.None) {
                            let output = getAutoGroupingText(value, field.autoGrouping);
                            obj.xGroupArgument += `${output}`;
                            obj.xGroupArgumentSort += stringfy(value);
                        }
                        else {
                            obj.xGroupArgument += `${value === null ? irSettings.nullText : value !== undefined ? value : ""}`;
                            obj.xGroupArgumentSort += stringfy(obj.xGroupArgument);
                        }
                    }
                }

                newResult.push(obj);
            }

            if (hasGroup) {

                let valueSeries = [];
                let index = {};

                for (const data of newResult) {
                    if (!index[data.xArgument]) {
                        index[data.xArgument] = 1;
                        valueSeries.push({
                            xArgument: data.xArgument,
                            xArgumentSort: data.xArgumentSort,
                        });
                    }
                };

                valueSeries.sort((a: any, b: any) => {
                    if (a.xArgumentSort < b.xArgumentSort) {
                        return -1;
                    }
                    if (a.xArgumentSort > b.xArgumentSort) {
                        return 1;
                    }
                    return 0;
                });

                this.chartVM.groupSerieValues = valueSeries;
                for (const data of newResult) {
                    for (const metricField of metricFields) {
                        for (const value of valueSeries) {
                            try {
                                data[`${metricField.queryName}_group_${value.xArgument}`] = data.xArgument === value.xArgument ? data[metricField.queryName] : undefined;
                            } catch (error) {
                                console.error(error);
                                throw new Error(error);
                            }
                        }
                    }
                }
            }

        }

        this.result.result = newResult;
        this.chartVM.dataSource = new DevExpress.data.DataSource({
            store: this.result.result,
            paginate: false,
        });

        return this.chartVM.dataSource;
    }

    //getPieChartOptions(chartType, chartDefinition, dataSource, metricFields, chartVM: ChartVM) {
    //    //"doughnut", //dxPieChart
    //    //    "pie", //dxPieChart

    //    let chartOptions = {
    //    };
    //    return chartOptions;
    //}

    //getPolarChartOptions(chartType, chartDefinition, dataSource, metricFields, chartVM: ChartVM) {
    //    //"", //polar dxPolarChart
    //    //    "", //radar dxPolarChart
    //    //    "", //radar area dxPolarChart

    //    let chartOptions = {
    //    };
    //    return chartOptions;
    //}

    log(message: string) {
        if (this.chartVM.debug)
            console.log(message);
    }

    pushStatus(status: ChartStatus) {
        this.log(`Chart Status pushing: ${status}`);
        this.chartVM.chartStatus.push(status);
    }

    popStatus() {
        let status = this.chartVM.chartStatus.pop();
        this.log(`Chart Status poping: ${status}`);
        return status;
    }

    getStatus() {
        let status = this.chartVM.chartStatus[this.chartVM.chartStatus.length - 1];
        this.log(`Chart Status getting: ${status}`);
        return status;
    }

    setupSettings() {
        this.createSettingItem(this.itemConfig.filterZeros, "filterZeros", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.keepMetricsDrillDown, "keepMetricsDrillDown", UpdateSettingMode.Reload);

        this.createSettingItem(this.itemConfig.chartDefinition.axisLabelDisplayMode, "chartDefinition.axisLabelDisplayMode", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.axisLabelAngle, "chartDefinition.axisLabelAngle", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.axisValueMargin, "chartDefinition.axisValueMargin", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.legendPosition, "chartDefinition.legendPosition", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.chartType, "chartDefinition.chartType", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.colorPerSerie, "chartDefinition.colorPerSerie", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelVisibility, "chartDefinition.labelVisibility", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.colorTheme, "chartDefinition.colorTheme", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelAlign, "chartDefinition.labelAlign", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelPosition, "chartDefinition.labelPosition", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelShowValue, "chartDefinition.labelShowValue", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelShowElement, "chartDefinition.labelShowElement", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelShowMetricName, "chartDefinition.labelShowMetricName", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelShowGroupingElement, "chartDefinition.labelShowGroupingElement", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelApplyBackgroundColor, "chartDefinition.labelApplyBackgroundColor", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelConnector, "chartDefinition.labelConnector", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelApplyBackgroundColor, "chartDefinition.labelApplyBackgroundColor", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelFontColor, "chartDefinition.labelFontColor", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelOverlapping, "chartDefinition.labelOverlapping", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelRotationAngle, "chartDefinition.labelRotationAngle", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelFormat, "chartDefinition.labelFormat", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.labelDecimalPlaces, "chartDefinition.labelDecimalPlaces", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.chartDefinition.showMetricsYAxis, "chartDefinition.showMetricsYAxis", UpdateSettingMode.Setup);
    }

    repaint() {
        //NOT IMPLEMENTED
    }

    runSetup() {
        this.createChart(true);
    }

    private applyObservable(chartVM: IChartVM) {
        let self: ChartWidget = this;

        let metricFields = self.itemConfig.metricFields();
        let chartDefinition = self.itemConfig.chartDefinition;

        for (let metricField of metricFields) {

            //Subscribe for changes on this properties
            metricField.visible.subscribe(function (value) {
                if (!value && metricFields.filter(function (x) { return x !== this && x.visible(); }.bind(this)).length === 0) {
                    this.visible(true);
                    return;
                }

                self.pushStatus(ChartStatus.ChangingProperties);
                if (value && chartDefinition.chartType() === ChartType.Bubble) {
                    if (this.yAxisChartDefinition.bubbleType() !== BubbleScatterType.YAxis)
                        this.yAxisChartDefinition.bubbleType(BubbleScatterType.YAxis);
                }
                if (value && chartDefinition.chartType() === ChartType.Scatter) {
                    if (this.yAxisChartDefinition.scatterType() !== BubbleScatterType.YAxis)
                        this.yAxisChartDefinition.scatterType(BubbleScatterType.YAxis);
                }
                self.popStatus();
                self.createChartAndSaveSettings();
            }, metricField);
            metricField.color.subscribe(self.createChartAndSaveSettings);
            metricField.yAxisChartDefinition.stackGroup.subscribe(self.createChartAndSaveSettings);
            metricField.yAxisChartDefinition.yAxisID.subscribe(self.createChartAndSaveSettings);
            metricField.yAxisChartDefinition.chartType.subscribe(self.createChartAndSaveSettings);
            metricField.yAxisChartDefinition.bubbleType.subscribe(function (value) {
                self.pushStatus(ChartStatus.ChangingProperties);
                if (this.yAxisChartDefinition.bubbleType() !== BubbleScatterType.YAxis) {
                    this.visible(false);

                    let field = metricFields.find(x => x.yAxisChartDefinition.bubbleType() == value && x.queryName !== this.queryName);
                    if (field)
                        field.yAxisChartDefinition.bubbleType(BubbleScatterType.YAxis);
                }
                else {
                    let field = metricFields.find(x => x.yAxisChartDefinition.bubbleType() === BubbleScatterType.YAxis && x.visible());
                    if (!field) {
                        field = metricFields.find(x => x.yAxisChartDefinition.bubbleType() === BubbleScatterType.YAxis);
                        field.visible(true);
                    }
                }
                self.popStatus();
                self.createChartAndSaveSettings();
            }, metricField);

            var scatterTypeManualChange = false;
            metricField.yAxisChartDefinition.scatterType.subscribe(function (value) {
                if (scatterTypeManualChange) {
                    scatterTypeManualChange = false;
                    return;
                }
                self.pushStatus(ChartStatus.ChangingProperties);
                if (this.yAxisChartDefinition.scatterType() === BubbleScatterType.XAxis) {
                    this.visible(false);

                    let field = metricFields.find(x => x.yAxisChartDefinition.scatterType() == value && x.queryName !== this.queryName);
                    if (field) {
                        scatterTypeManualChange = true;
                        field.yAxisChartDefinition.scatterType(BubbleScatterType.YAxis);
                        field.visible(true);
                    }
                }
                else {
                    let field = metricFields.find(x => x.yAxisChartDefinition.scatterType() === BubbleScatterType.YAxis && x.visible() && x.queryName !== this.queryName);
                    if (!field) {
                        field = metricFields.find(x => x.yAxisChartDefinition.scatterType() === BubbleScatterType.YAxis && x.queryName !== this.queryName);
                        field.visible(true);
                    }

                    if (field) {
                        scatterTypeManualChange = true;
                        field.visible(false);
                        field.yAxisChartDefinition.scatterType(BubbleScatterType.XAxis);
                    }

                    this.visible(true);
                }
                self.popStatus();
                self.createChart();
            }, metricField);
        }
    }

    private onDrillDown(e) {
        let self = this;

        if (!self.isDrilldownPossible)
            return;

        var xAxisFields = [...self.chartVM.result.xAxisFields];
        if (self.chartVM.result.groupFields) {

            self.chartVM.result.groupFields.forEach(field => {
                xAxisFields.push(field);
            });
        }

        let chartPoint = e.target.data;

        let tabValues: Array<FilterValuesVM> = [];
        for (let i = 0; i < xAxisFields.length; i++) {
            if (xAxisFields[i].isGroupBy) {
                let name = xAxisFields[i].name;
                let value = chartPoint[name];
                tabValues.push({ name: name, startCondition: value, isGroupField: xAxisFields[i].isGroupField });
            }
        }

        self.executeDrilldown(tabValues);
    }

    override print() {
        let href = `/Email/Html?scope=Report&mappingId=${this.tab.workbookConfig.mappingId}&workbookId=${this.tab.workbookConfig.workbookId()}&tabId=${this.tab.workbookConfig.activeTab().id()}&print=True&em=False`;
        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }
        window.open(href, "_blank").focus();
    }

    override exportToPDF(isLandscape: boolean, templateId: number) {
        let href = `/Email/Pdf?scope=Report&mappingId=${workbook.workbookConfig.mappingId}&workbookId=${workbook.workbookConfig.workbookId()}&tabId=${workbook.workbookConfig.activeTab().id()}`;
        if (isLandscape) {
            href += `&landscape=${isLandscape}`;
        }

        if (templateId && templateId > 0) {
            href += `&pdfTemplateId=${templateId}`;
        }

        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }

        window.open(href, "_blank").focus();
    }

    override exportToXLSX(withoutHeaders: boolean) {
        let href = `/Email/Excel?scope=Report&mappingId=${workbook.workbookConfig.mappingId}&workbookId=${workbook.workbookConfig.workbookId()}&tabId=${workbook.workbookConfig.activeTab().id()}&withoutHeaders=${withoutHeaders}`;
        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }

        window.open(href, "_blank").focus();
    }

    override exportToCSV(withoutHeaders: boolean) {
        let href = `/Email/CSV?scope=Report&mappingId=${workbook.workbookConfig.mappingId}&workbookId=${workbook.workbookConfig.workbookId()}&tabId=${workbook.workbookConfig.activeTab().id()}&withoutHeaders=${withoutHeaders}`;
        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }

        window.open(href, "_blank").focus();
    }
}